import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';
import { useGetDropdownItemsByCategory } from 'src/hooks/dropdownMenu.hooks';

// This will be populated from database
export const getStudentTypeOptions = (subRoleData?: { lmsTechStacks?: Array<{ name: string; label?: string | undefined }> | undefined } | undefined) => {
	if (!subRoleData?.lmsTechStacks) return [];

	// Filter specific roles that should appear in student type filter
	const allowedRoles = ['MasaiStudent', 'MasaiAlum', 'CAP', 'CollegeStudents'];
	return subRoleData.lmsTechStacks
		.filter(item => allowedRoles.includes(item.name))
		.map(item => ({
			value: item.name,
			label: item.label || item.name,
		}));
};

const StudentTypeFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const studentType = JSON.parse(searchParams.get('studentType') || '[]');

	// Fetch SubRole items from database (all active items, not filtered by showInMenu - for filtering)
	const { data: subRoleData } = useGetDropdownItemsByCategory('SUB_ROLE', undefined, true);
	const options = getStudentTypeOptions(subRoleData);

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!studentType?.length}
					placeholder={'Student Type'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: studentType?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (studentType?.includes(option?.value?.toString())) {
											searchParams.set(
												'studentType',
												JSON.stringify(studentType?.filter((st: string) => st !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('studentType', JSON.stringify([...studentType, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{studentType?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Student Type</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="CAP"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => studentType?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('studentType', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default StudentTypeFilterInput;
